<template>
  <button
      :type="type"
      :class="class"
      :id="id"
      :disabled="disabled || loading"
  >
    <span v-if="loading" class="flex items-center">
        <span class="loading loading-spinner"></span>
        <span class="ml-2">Loading</span>
    </span>
    <span v-else>
      <slot>Continue</slot>
    </span>
  </button>
</template>

<script>
import { computed } from "vue";

export default {
  name: "ButtonComponent",
  props: {
    type: {
      type: String,
      default: "button"
    },
    class: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // Compute button class
    // const computedClass = computed(() => {
    //   return `${props.class} ${props.loading ? "opacity-50 cursor-not-allowed" : ""}`;
    // });

    return {
      //computedClass,
    };
  },
};
</script>

<style scoped>
.loader {
  border: 2px solid #f3f3f3; /* Light gray */
  border-top: 2px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 8px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>